export default "__VITE_ASSET__Bo0jproV__";